import { pathOr } from 'ramda';

import * as Drive from './googleAPIHandler.drive';
import * as Slides from './googleAPIHandler.slides';
import { getRefreshAccessToken } from './googleAPIHandler.helpers';
import {
  RESPONSE_SUCCESS,
  TOKEN_FAILURE,
  TEMPLATE_COPY_FAILURE,
  SLIDE_BATCH_UPDATE_FAILURE,
  responseFormatter,
  errorFormatter,
} from './googleAPIHandler.errors';

export default class GoogleAPI {
  private accessToken = '';

  private async withErrorHandling(
    untilGetResult: Promise<any>,
    errorMessage: string,
  ) {
    try {
      const response = await untilGetResult;
      return responseFormatter(response);
    } catch (error) {
      return Promise.reject(errorFormatter(error, errorMessage));
    }
  }

  public initClient = async (): Promise<void> => {
    await new Promise((resolve, reject) => {
      gapi.load('client:auth2', async () => {
        try {
          const getRefreshAccessTokenResponse = await getRefreshAccessToken();
          this.accessToken = pathOr(
            '',
            ['result', 'access_token'],
            getRefreshAccessTokenResponse,
          );

          gapi.client.setToken({
            access_token: this.accessToken,
          });

          resolve(RESPONSE_SUCCESS);
        } catch (error) {
          reject(errorFormatter(error, TOKEN_FAILURE));
        }
      });
    });
  };

  public copyFile = (templateTitle: string) =>
    this.withErrorHandling(
      Drive.copyFile(templateTitle),
      TEMPLATE_COPY_FAILURE,
    );

  public slideBatchUpdate = (
    presentationId: string,
    requests: any,
  ): Promise<any> =>
    this.withErrorHandling(
      Slides.batchUpdate(presentationId, requests),
      SLIDE_BATCH_UPDATE_FAILURE,
    );
}
